module.exports = __webpack_public_path__ + "img/propaq_md.0d0d875c.png";